<span
  *ngIf="status$ | async as status"
  class="label mat-caption"
  [ngClass]="status.id | lowercase"
  data-cy="hiring-manager-status"
>
  {{ status.label }}
</span>
